import React from 'react';

interface DefaultAvatarProps {
    size?: number;
    className?: string;
}

const DefaultAvatar: React.FC<DefaultAvatarProps> = ({ 
    size = 40, 
    className = "" 
}) => {
    return (
        <div 
            className={`flex items-center justify-center ${className}`}
            style={{ width: size, height: size }}
        >
            <svg 
                width={size} 
                height={size} 
                viewBox="0 0 43 43" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className="rounded-full"
            >
                <g clipPath="url(#clip0_17795_17210)">
                    <path 
                        d="M21.5433 0.890503C20.3222 0.890503 19.0839 0.994635 17.8369 1.22026C12.2686 2.21819 7.28925 5.54174 4.18905 10.3405C1.08884 15.1219 0.0929648 21.0054 1.44389 26.4723C3.60884 35.2368 11.3853 41.6583 20.3482 42.0835C24.453 42.2831 27.8822 41.5281 30.8352 39.7839L30.8785 39.7579C31.4761 39.4108 32.0909 39.0463 32.6625 38.6558C38.5944 34.6988 41.8765 28.9975 42.1536 22.1769C42.1363 19.9293 41.9804 18.3934 41.634 16.8748C39.4604 7.37273 31.0084 0.890503 21.5433 0.890503Z" 
                        fill="#E3F7F3"
                    />
                    <path 
                        d="M42.5001 22.1942C42.2316 28.9107 39.0968 34.7855 32.853 38.9508C32.2555 39.35 31.632 39.7231 31.0085 40.0876C27.7091 42.0401 24.0807 42.6128 20.331 42.4306C11.1429 41.9967 3.32314 35.4971 1.10624 26.5591C-1.78614 14.8703 5.91242 3.00785 17.7763 0.873142C28.8955 -1.12273 39.4605 5.8281 41.9805 16.8054C42.3269 18.3326 42.4827 19.8773 42.5001 22.1942ZM17.2135 24.8583C16.9277 24.6153 16.6939 24.4331 16.486 24.2335C14.399 22.3504 13.4291 20.0248 13.9747 17.2306C14.5895 14.0806 16.5553 12.0587 19.5603 11.0521C20.6427 10.6876 21.7685 10.6095 22.8943 10.8264C26.67 11.5554 29.2939 15.0264 28.9302 18.862C28.7829 20.4587 28.4712 22.0293 27.5879 23.4091C27.5532 23.4698 27.3714 23.7649 27.3714 23.7649C27.3714 23.7649 27.9862 24.0252 28.2114 24.1033C30.792 25.0665 33.0349 26.5417 34.9314 28.5376C35.9966 29.657 37.0444 31.219 37.1743 32.7116C40.4563 28.555 42.3269 20.2244 38.5772 12.9004C34.6976 5.35083 26.5487 1.26364 18.0968 2.66942C10.0431 4.01446 3.72149 10.6008 2.5351 18.9141C1.38335 27.0103 5.70459 33.9698 9.86129 36.7207C10.8312 31.8698 12.8836 27.6698 17.2135 24.8583Z" 
                        fill="#00B98B"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_17795_17210">
                        <rect width="42" height="42" fill="white" transform="translate(0.5 0.5)"/>
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};

export default DefaultAvatar;

